import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SidebarCustom from '../../common/Layout/Sidebar';
import HouseIcon from 'apollo-react-icons/House';
import MedicalCard from 'apollo-react-icons/MedicalCard';
import ChevronLeft2 from 'apollo-react-icons/ChevronLeft2';
import FileAccountPlan from 'apollo-react-icons/FileAccountPlan';
import Bell from 'apollo-react-icons/Bell';
import CardView from 'apollo-react-icons/CardView';
import Hotel from 'apollo-react-icons/Hotel';
import { logout } from '../services/authService';
import PresentationHierarchyLight from 'apollo-react-icons/PresentationHierarchyLight';
import StatusCheck from 'apollo-react-icons/StatusCheck';
import Planner from 'apollo-react-icons/Planner';
// import { useAuth } from '../../../Contexts/Auth';

const Sidebar = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  // const{isAuthenticated}= useAuth()

  let menuItems = [
    {
      text: t('dashboard'),
      icon: HouseIcon,
      handleOnClick: () => {
        navigate('/super-admin/home');
      },
      pathname: '/super-admin/home',
    },
    {
      text: t('user_management'),
      icon: MedicalCard,
      menuItems: [
        {
          text: t('role_groups'),
          handleOnClick: () => {
            navigate('/super-admin/roles');
          },
          pathname: '/super-admin/roles',
          parentName: t('user_management'), // Custom tag to identify parent
        },
        {
          text: t('admin_users'),
          handleOnClick: () => {
            navigate('/super-admin/users');
          },
          pathname: '/super-admin/users',
          parentName: t('user_management'), // Custom tag to identify parent
        },
        // {
        //   text: t('end-users'),
        //   handleOnClick: () => {
        //     navigate('/super-admin/endusers');
        //   },
        //   pathname: '/super-admin/endusers',
        // },
        {
          text: t('External-user Categories'),
          handleOnClick: () => {
            navigate('/super-admin/categories');
          },
          pathname: '/super-admin/categories',
          parentName: t('user_management'), // Custom tag to identify parent
        },
      ]
    },
    {
      text: t('form_management'),
      icon: Planner,
      menuItems: [
        {
          text: t('Subforms'),
          handleOnClick: () => {
            navigate('/super-admin/subforms');
          },
          pathname: '/super-admin/subforms',
          parentName: t('form_management'), // Custom tag to identify parent
        },
        {
          text: t('forms'),
          handleOnClick: () => {
            navigate('/super-admin/forms');
          },
          pathname: '/super-admin/forms',
          parentName: t('form_management'), // Custom tag to identify parent
        },
      ]
    },
    {
      text: t('workflow_management'),
      handleOnClick: () => {
        navigate('/super-admin/workflows');
      },
      icon: PresentationHierarchyLight,
      pathname: '/super-admin/workflows',
    },
    {
      text: t('Requests'),
      handleOnClick: () => {
        navigate('/super-admin/approvals');
      },
      icon: StatusCheck,
      pathname: '/super-admin/approvals',
    },
    {
      text: t('Notification & Reminders'),
      icon: Bell,
      handleOnClick: () => {
        navigate('/super-admin/reminders');
      },
      pathname: '/super-admin/reminders',
    },
    {
      text: t('Product Details'),
      icon: CardView,
      handleOnClick: () => {
        navigate();
      },
      pathname: '',
    },
    {
      text: t('Manufacturers Site'),
      icon: Hotel,
      handleOnClick: () => {
        navigate();
      },
      pathname: '',
    },
    { 
      text: t('audit_logs'),
      icon: FileAccountPlan,
      menuItems: [
        // {
        //   text: t('other'),
        //   handleOnClick: () => {
        //     navigate('/super-admin/logs/other');
        //   },
        //   pathname: '/super-admin/logs/other',
        // },
        {
          text: t('Role groups'),
          handleOnClick: () => {
            navigate('/super-admin/logs/roles');
          },
          pathname: '/super-admin/logs/roles',
          parentName: t('audit_logs'), // Custom tag to identify parent
        },
        {
          text: t('Admin Users'),
          handleOnClick: () => {
            navigate('/super-admin/logs/users');
          },
          pathname: '/super-admin/logs/users',
          parentName: t('audit_logs'), // Custom tag to identify parent
        },
        {
          text: t('Categories'),
          handleOnClick: () => {
            navigate('/super-admin/logs/categories');
          },
          pathname: '/super-admin/logs/categories',
          parentName: t('audit_logs'), // Custom tag to identify parent
        },
        {
          text: t('Subforms'),
          handleOnClick: () => {
            navigate('/super-admin/logs/subforms');
          },
          pathname: '/super-admin/logs/subforms',
          parentName: t('audit_logs'), // Custom tag to identify parent
        },
        {
          text: t('Forms'),
          handleOnClick: () => {
            navigate('/super-admin/logs/forms');
          },
          pathname: '/super-admin/logs/forms',
          parentName: t('audit_logs'), // Custom tag to identify parent
        },

        {
          text: t('workflows'),
          handleOnClick: () => {
            navigate('/super-admin/logs/workflows');
          },
          pathname: '/super-admin/logs/workflows',
          parentName: t('audit_logs'), // Custom tag to identify parent
        },
      ],
    },
    // {
    //   text: i18n.language === 'en' ? 'عربي' : 'English',
    //   icon: HouseIcon,
    //   handleOnClick: () => {
    //     toggleLanguage();
    //   }
    // },
    // {
    //   text: t('sign_out'),
    //   icon: HouseIcon,
    //   handleOnClick: handleLogout,
    // },
    {
      text: t('sign_out'),
      icon: ChevronLeft2,
      href: '/login',
      handleOnClick: () => { logout (); navigate('/login'); },
    }
  ];
  // let menuItems = [
  //   {
  //     text: t('dashboard'),
  //     icon: HouseIcon,
  //     handleOnClick: () => {
  //       navigate('/super-admin/home');
  //     },
  //     pathname: '/super-admin/home',
  //   },
  //   {
  //     text: t('user_management'),
  //     icon: MedicalCard,
  //     menuItems: [
  //       {
  //         text: t('users'),
  //         handleOnClick: () => {
  //           navigate('/super-admin/users');
  //         },
  //         pathname: '/super-admin/users',
  //       },
  //       {
  //         text: t('role_groups'),
  //         handleOnClick: () => {
  //           navigate('/super-admin/roles');
  //         },
  //         pathname: '/super-admin/roles',
  //       },
  //       {
  //         text: t('End-user Categories'),
  //         handleOnClick: () => {
  //           navigate('/super-admin/categories');
  //         },
  //         pathname: '/super-admin/categories',
  //       },
  //     ]
  //   },
  //   {
  //     text: t('Notification & Reminders'),
  //     icon: Bell,
  //     handleOnClick: () => {
  //       navigate('/super-admin/reminders');
  //     },
  //     pathname: '/super-admin/reminders',
  //   },
  //   {
  //     text: t('audit_logs'),
  //     icon: FileAccountPlan,
  //     menuItems: [
  //       {
  //         text: t('other'),
  //         handleOnClick: () => {
  //           navigate('/super-admin/logs/other');
  //         },
  //         pathname: '/super-admin/logs/other',
  //       },
  //       {
  //         text: t('users'),
  //         handleOnClick: () => {
  //           navigate('/super-admin/logs/users');
  //         },
  //         pathname: '/super-admin/logs/users',
  //       },
  //       {
  //         text: t('roles'),
  //         handleOnClick: () => {
  //           navigate('/super-admin/logs/roles');
  //         },
  //         pathname: '/super-admin/logs/roles',
  //       },
  //       {
  //         text: t('workflows'),
  //         handleOnClick: () => {
  //           navigate('/super-admin/logs/workflows');
  //         },
  //         pathname: '/super-admin/logs/workflows',
  //       },
  //     ],
  //   },
  //   {
  //     text: t('sign_out'),
  //     icon: ChevronLeft2,
  //     href: '/login',
  //     handleOnClick: () => { logout (); navigate('/login'); },
  //   }
  // ];

  return (
    <SidebarCustom
    isSidebarCollapsed={props.isSidebarCollapsed}
    setIsSidebarCollapsed={props.setIsSidebarCollapsed}
    menuItems={menuItems}
    />
  );
}

export default Sidebar;